/**
 * Entity types for field-info list prefetch and label map.
 * Keep in sync with scripts/fetch-field-infos.ts ENTITY_TYPES when adding new types.
 */
export const FIELD_INFO_ENTITY_TYPES = [
	"Address",
	"AuditLog",
	"ColumnDefinition",
	"ColumnDefinitionVersion",
	"DomainObjectBase",
	"DomainObjectBaseWithSoftDelete",
	"Entity",
	"EntityData",
	"EntityDefinition",
	"EntityDefinitionVersion",
	"EntityReportingConnection",
	"FileInfo",
	"Job",
	"JobAssignment",
	"JobFile",
	"JobStatus",
	"JobStatusLifecycle",
	"JobStatusValidTransition",
	"JobSubContractor",
	"JobType",
	"Localization",
	"LocalizationValue",
	"OAuthProvider",
	"Organization",
	"OrganizationContact",
	"OrganizationRole",
	"OrganizationRolePermission",
	"OrganizationSetting",
	"OrganizationUser",
	"PlatformSetting",
	"SubContractor",
	"SubContractorAccess",
	"SubOrganization",
	"Ticket",
	"TicketAssignment",
	"TicketPriority",
	"TicketStatus",
	"TicketStatusLifecycle",
	"TicketStatusValidTransition",
	"TicketSubContractor",
	"TicketType",
	"User",
	"UserConfiguration",
	"UserDataAccess",
	"UserInvite",
	"UserRole",
	"UserSession",
	"UserSystemRole",
] as const;

export type FieldInfoEntityType = (typeof FIELD_INFO_ENTITY_TYPES)[number];
